import { Box, Grid, Paper, Table, TableBody, TableCell, TableHead, TableRow, Typography } from "@mui/material";
import React from "react";
import CustomTableILayout from "./CustomTableILayout";
const tutorHeader = [
  { displayName: "Tutor ID", key: "id" },
  { displayName: "Name", key: "name" },
  { displayName: "Batch", key: "batch" },
  { displayName: "Amount", key: "amount" },
  { displayName: "Status", key: "status" },
];

const batchAttendanceHeader = [
  { displayName: "Batch", key: "batch" },
  { displayName: "Session Held", key: "sessionHeld" },
  { displayName: "Total Students", key: "totalStudents" },
  { displayName: "Attendance Rate", key: "attendanceRate" },
];

const refundHeader = [
  { displayName: "Refund Id", key: "expense_id" },
  { displayName: "Student", key: "student_name" },
  { displayName: "Amount", key: "refund" },
  { displayName: "Status", key: "status" },
];

const refferalHeader = [
  { displayName: "Lead Name", key: "name" },
  { displayName: "Batch Name", key: "course_batch_name" },
  { displayName: "Mobile Number", key: "mob_no" },
];

const TableSection = ({ recentTutorPayments, batchAttendanceAndStudents, refunds, employeeReferralLeads }) => {
  return (
    <Grid container spacing={2}>
      <Grid item xs={12} sm={12} md={6}>
        <CustomTableILayout
          tableName={"Batch Attendance & Students"}
          colorInvert={true}
          tableHeader={batchAttendanceHeader}
          tableRows={batchAttendanceAndStudents}
        />
      </Grid>
      <Grid item xs={12} sm={12} md={6}>
        <CustomTableILayout tableName={"Employee Referral Leads"} colorInvert={true} tableHeader={refferalHeader} tableRows={employeeReferralLeads} />
      </Grid>

      <Grid item xs={12} sm={12} md={6}>
        <CustomTableILayout tableName={"Refunds : Raised & Approved"} tableHeader={refundHeader} tableRows={refunds} />
      </Grid>
      <Grid item xs={12} sm={12} md={6}>
        <CustomTableILayout tableName={"Recent Tutor Payments"} tableHeader={tutorHeader} tableRows={recentTutorPayments} />
      </Grid>
    </Grid>
  );
};

export default TableSection;
